import { render, staticRenderFns } from "./AddDocs.vue?vue&type=template&id=1d75097a&scoped=true&"
import script from "./AddDocs.vue?vue&type=script&lang=js&"
export * from "./AddDocs.vue?vue&type=script&lang=js&"
import style0 from "./AddDocs.vue?vue&type=style&index=0&id=1d75097a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d75097a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VSelect})
